var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.active,"mode":"horizontal"},on:{"select":_vm.handleSelect}},_vm._l((_vm.menuList),function(item){return _c('el-menu-item',{key:item.index,attrs:{"index":item.index}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }